import {PRIVACY_STATEMENTS} from '../actions/types';

const INTIAL_STATE = [];

export default (state = INTIAL_STATE,action) => {
    switch(action.type){
        case PRIVACY_STATEMENTS:
            return action.payload;
        default:
            return state;
    }
}